/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Chat_Tool_Confirm_Generic_TitleInputs */



/**
* | output |
* | --- |
* | "This action needs your confirmation: {tool}" |
*
* @param {Chat_Tool_Confirm_Generic_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_generic_title = /** @type {((inputs: Chat_Tool_Confirm_Generic_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Generic_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Aktion muss bestätigt werden: ${i?.tool}`)
	return /** @type {LocalizedString} */ (`This action needs your confirmation: ${i?.tool}`)
});